import React from 'react'

const Gauge = ({ value = 0, color = '#22C55E', size = 40, stroke = 6 }) => {
  // value: 0-100
  const radius = (size - stroke) / 2
  const circumference = 2 * Math.PI * radius
  const offset = circumference * (1 - value / 100)

  return (
    <svg width={size} height={size / 2} viewBox={`0 0 ${size} ${size / 2}`}>
      <path
        d={`M${stroke / 2},${size / 2} A${radius},${radius} 0 0,1 ${size - stroke / 2},${size / 2}`}
        fill="none"
        stroke="#E5E7EB"
        strokeWidth={stroke}
      />
      <path
        d={`M${stroke / 2},${size / 2} A${radius},${radius} 0 0,1 ${size - stroke / 2},${size / 2}`}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
      />
    </svg>
  )
}

export default Gauge 